import { useEffect, useState } from "react";
import { LanguagesContext } from "./LanguageContext";
import { LanguageResource } from "@modules/profile/features/configuration/resources/Language.resource";
import { LanguageViewModel } from "@viewModels/Language.viewModel";
import { initI18Nexeus } from "@config/i18n";
import { Loading } from "@components/Loading";

export interface State {
  count: number;
  items: LanguageViewModel[];
}

const initialState: State = {
  count: 0,
  items: [],
};

export const LanguagesContextProvider = ({ children }: any) => {
  const [languages, setLanguages] = useState<State>(initialState);
  const [isLoading, setIsLoading] = useState(true);

  const getSupportedLanguages = (state: State) => {
    if (state.count === 0 || state.items.length === 0) {
      return ["en"];
    } else {
      const codes = state.items
        .filter((it) => it.i18nexusId != null && it.i18nexusId !== "")
        .map((it) => it.i18nexusId!);
      return codes.length > 0 ? codes : ["en"];
    }
  };

  useEffect(() => {
    const loadLanguages = async () => {
      let state: State = initialState;
      try {
        const response = await LanguageResource.getLanguages();
        state = {
          count: response.data.count,
          items: response.data.items.map((it) => new LanguageViewModel(it)),
        };
      } catch (e) {
        state = initialState;
      } finally {
        const supportedLanguages = getSupportedLanguages(state);
        await initI18Nexeus(supportedLanguages);
        setLanguages(state);
        setIsLoading(false);
      }
    };

    loadLanguages();
  }, []);

  // This tells Suspense to wait until data is ready
  if (isLoading) {
    return <Loading />;
  }

  return (
    <LanguagesContext.Provider value={languages}>
      {children}
    </LanguagesContext.Provider>
  );
};
